export function getLeaderboardTotalParticipants(leaderboardResult) {
  const pagination = leaderboardResult?.pagination ?? {};
  const totalPages = Number(pagination.totalPages) || 1;
  const userList = Array.isArray(leaderboardResult?.user_list)
    ? leaderboardResult.user_list
    : [];
  const listLen = userList.length;
  const pageSize =
    Number(pagination.pageSize) ||
    Number(pagination.limit) ||
    Number(pagination.perPage) ||
    listLen ||
    10;

  const explicitTotal =
    Number(pagination.totalCount) ||
    Number(pagination.totalRecords) ||
    Number(pagination.totalUsers) ||
    Number(pagination.total) ||
    Number(leaderboardResult?.competition?.totalUsers) ||
    Number(leaderboardResult?.competition?.participantCount) ||
    0;

  if (explicitTotal > 0) return explicitTotal;

  if (totalPages > 1) return totalPages * pageSize;

  if (listLen > 0) {
    const maxRankOnPage = userList.reduce(
      (max, user) => Math.max(max, Number(user?.rank) || 0),
      0
    );
    return Math.max(listLen, maxRankOnPage);
  }

  return 0;
}

export function isBelowFiftyPercentPlacement(value) {
  if (value == null || value === "") return false;
  const normalized = String(value).trim().toLowerCase().replace(/\s+/g, " ");
  return normalized === "below 50%" || normalized === "below50%";
}

export function computeTopPercentFromRank(rank, totalParticipants) {
  if (!Number.isFinite(rank) || rank <= 0) return null;

  const total = Math.max(Number(totalParticipants) || 0, rank);
  if (total <= 0) return null;

  if (total === 1) return 1;

  if (total === 2) {
    return rank === 1 ? 1 : 50;
  }

  let pct = Math.ceil((rank / total) * 100);

  if (pct >= 100 && rank > 1) {
    pct = Math.min(99, Math.ceil(((rank - 0.5) / total) * 100));
  }

  return Math.min(100, Math.max(1, pct));
}

export function resolveTopPercent(userRank, leaderboardResult) {
  const rawPct = Number(
    userRank?.percentile ?? userRank?.topPercent ?? userRank?.top_percent
  );
  if (Number.isFinite(rawPct) && rawPct > 0) {
    return Math.min(100, Math.round(rawPct));
  }

  const rank = Number(userRank?.rank);
  const total = leaderboardResult
    ? getLeaderboardTotalParticipants(leaderboardResult)
    : 0;
  const computed = computeTopPercentFromRank(rank, total);
  if (computed != null) return computed;

  return 5;
}

/**
 * TOP % for the leading half; BOTTOM (100 − top%) for ranks worse than top 50%.
 * Used for the "CURRENT PLACEMENT" panel only (table column keeps TOP %).
 */
export function formatPlacementBracketLabel(topPct) {
  const pct = Math.min(100, Math.max(1, Math.round(Number(topPct) || 0)));
  if (pct > 50) {
    return `BOTTOM ${100 - pct}%`;
  }
  return `TOP ${pct}%`;
}

export function formatCurrentPlacementDisplay(userRank, leaderboardResult) {
  const rank = Number(userRank?.rank);
  if (!Number.isFinite(rank) || rank <= 0) return "—";

  const topPct = resolveTopPercent(userRank, leaderboardResult);
  const bracket = formatPlacementBracketLabel(topPct);
  return `${bracket} ✧ RANK #${rank}`;
}
